import React, { useEffect } from 'react';
import { EditorState } from '@codemirror/state';
import { EditorView, keymap, lineNumbers, gutter } from '@codemirror/view';
import { defaultKeymap } from '@codemirror/commands';
import {
  syntaxHighlighting,
  defaultHighlightStyle,
} from '@codemirror/language';
import { html as htmlFormatting } from '@codemirror/lang-html';
import styled, { css } from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, HtmlContent } from './ui';

const StyledHtml = styled.section`
  ${({ isBlogDetail }) => {
    if (!isBlogDetail) {
      return css`
        ${sectionMargins()};
      `;
    } else {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    }
  }}
`;

const StyledContainer = styled(Container)`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        padding-left: 0;
        padding-right: 0;
      `;
    }
  }};
`;

const Html = ({ html, isBlogDetail }) => {
  useEffect(() => {
    const codeElements = document.querySelectorAll(
      'textarea[id*="fusion_syntax_highlighter"]',
    );

    if (codeElements.length > 0) {
      codeElements.forEach(element => {
        let codeContainer = document.createElement('div');
        element.before(codeContainer);

        // Set up Code mirror
        let startState = EditorState.create({
          // Use the textarea's value as the initial text for CodeMirror
          doc: element.value,
          extensions: [
            keymap.of(defaultKeymap),
            lineNumbers(),
            gutter({ class: 'cm-mygutter' }),
            EditorView.editable.of(false),
            htmlFormatting(),
            syntaxHighlighting(defaultHighlightStyle),
          ],
        });

        new EditorView({
          state: startState,
          parent: codeContainer,
        });

        element.setAttribute('hidden', 'true');
      });
    }
  }, []);

  return (
    <StyledHtml isBlogDetail={isBlogDetail}>
      <StyledContainer narrower={isBlogDetail} isBlogDetail={isBlogDetail}>
        <HtmlContent html={html} />
      </StyledContainer>
    </StyledHtml>
  );
};

export default Html;
